import { CommonModule } from '@angular/common';
import { Component, TemplateRef, computed, effect, inject, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { slideInLeft, slideInRight } from '../../shared/animations/animations';
import { HeaderLayoutComponent } from '../../shared/header-layout/header-layout.component';
import { AppBannerComponent } from "../app-banner/app-banner.component";
import { FooterComponent } from '../footer/footer.component';
import { ModalsComponent } from "../modals/modals.component";
import { ItemEditorService } from '../services/item-editor.service';
import { LayoutService } from '../services/layout.service';
import { ModalService } from '../services/modal.service';
import { OrderService } from '../services/order.service';
import { PathService } from '../services/path.service';
import { SocialLinksService } from '../services/social-links.service';
import { StoreStatusService } from '../services/store-status.service';
import { TopBannerComponent } from '../top-banner/top-banner.component';
import { TranslocoDirective } from '@ngneat/transloco';
import { HeaderLogoComponent } from "../../shared/header-logo/header-logo.component";
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'cwo-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    TopBannerComponent,
    HeaderLayoutComponent,
    FooterComponent,
    ModalsComponent,
    AppBannerComponent,
    TranslocoDirective,
    HeaderLogoComponent
],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  animations: [slideInLeft(), slideInRight()],
})
export class LayoutComponent  {
  layoutService = inject(LayoutService);
  modalService = inject(ModalService);
  itemEditorService = inject(ItemEditorService);
  storeStatusForBanner = inject(StoreStatusService).storeStatusForBanner;
  pathService = inject(PathService);
  orderService = inject(OrderService);
  private socialLinksService = inject(SocialLinksService);
  private configService = inject(ConfigService);
  store = this.configService.configState().store;
  
  showBanner = computed(() => { return this.socialLinksService.showBanner()})


  public readonly couponConfirmationInstructionsModalTemplateRef = viewChild.required<TemplateRef<any>>('couponConfirmationInstructionsModal');

  constructor() {
    effect(() => {
      if(!this.storeStatusForBanner() || !this.storeStatusForBanner()?.statusMessage) {
        const topBanner = document.getElementById('top-banner');
        if(topBanner) {
          document.documentElement.style.setProperty('--top-banner-height', '0px');
          topBanner.style.visibility = 'hidden';
        }
      }
    })
  }

  
  onSkipToMain(event: Event) {
    event.preventDefault();
    const main = document.getElementById('main-content') as HTMLElement | null;
    if (main) {
      if (!main.hasAttribute('tabindex')) {
        main.setAttribute('tabindex', '-1');
      }
      try {
        (main as any).focus({ preventScroll: false });
      } catch {
        main.focus();
      }
    }
  }

}
